"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _wxOfficialAdmin = require("@/api/wxOfficialAdmin");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: '',
  data: function data() {
    return {
      ruleForm: {
        wechatAppName: '',
        greetingContent: '',
        wechatAppId: '',
        wechatAppSecret: '',
        aesKey: '',
        token: '',
        serviceUrl: '',
        domain: '',
        appNo: sessionStorage.getItem('appNo') || ''
      },
      rules: {
        wechatAppName: [{
          required: true,
          message: '请填写公众号名称',
          trigger: 'blur'
        }],
        wechatAppId: [{
          required: true,
          message: '请填写公众号AppID',
          trigger: 'blur'
        }],
        wechatAppSecret: [{
          required: true,
          message: '请填写公众号AppSecret',
          trigger: 'blur'
        }],
        aesKey: [{
          required: false,
          message: '请填写消息加解密密钥',
          trigger: 'blur'
        }],
        token: [{
          required: false,
          message: '请填写令牌(Token)',
          trigger: 'blur'
        }],
        serviceUrl: [{
          required: false,
          message: '请填写服务器地址',
          trigger: 'blur'
        }],
        domain: [{
          required: false,
          message: '请填写JS接口安全域名',
          trigger: 'blur'
        }]
      }
    };
  },
  mounted: function mounted() {
    this.inIt();
  },
  methods: {
    inIt: function inIt() {
      var _this = this;
      (0, _wxOfficialAdmin.getInfo)().then(function (res) {
        if (res.data) {
          _this.ruleForm = (0, _objectSpread2.default)({}, res.data);
          console.log(_this.ruleForm);
        }
      });
    },
    submitForm: function submitForm(formName) {
      var _this2 = this;
      this.$refs[formName].validate(function (valid) {
        if (valid) {
          _this2.$confirm('是否确认保存内容?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(function () {
            if (!_this2.ruleForm.appNo || _this2.ruleForm.appNo === null || _this2.ruleForm.appNo === undefined) {
              _this2.ruleForm.appNo = sessionStorage.getItem('appNo');
            }
            (0, _wxOfficialAdmin.saveOrUpdate)(_this2.ruleForm).then(function (res) {
              if (res.data) {
                _this2.$notify.success({
                  title: '温馨提示',
                  message: '保存成功！'
                });
              }
            }).then(function () {
              _this2.inIt();
            });
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};